<template>
  <!-- TOP CARD -->
  <section class="px-4 py-4 mb-3 text-white dark-with-overlay rounded-xl">
    <div class="flex">
      <div>
        <div
          class="px-4 py-1 text-xs uppercase border border-gray-100 rounded-full w-fit gap-x-2 flex-items-center"
        >
          <p>{{ translateText(`supply.totalAmt`) }}</p>
        </div>

        <p class="mt-4 text-[1.75rem] font-millik">
          {{ currencyFormat(totalAmount) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { currencyFormat, translateText } from "@/core/helpers/utility";

export default {
  props: {
    totalAmount: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      translateText,
      currencyFormat,
    };
  },
};
</script>
